module.exports = __webpack_public_path__ + "img/ax-icon.72ef92e6.svg";